import { OfCustomerPage } from './OfCustomerPage';
import { DetailPage } from './DetailPage'

export {
    OfCustomerPage,
    DetailPage
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/FrontofficeUsers/index.ts
 **/